<template>
  <div>
    <!-- button on right -->
    <b-input-group>
      <b-form-input
        v-model="coordinate"
        :placeholder="$t('_components.placeholder.check')+label"
      />
      <b-input-group-append>
        <b-button
          variant="outline-primary"
          @click="handleCheckClick(label)"
        >
          <feather-icon
            icon="MapPinIcon"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <!-- modal -->

    <b-modal
      v-if="modalVisible"
      v-model="modalVisible"
      cancel-variant="outline-secondary"
      :modal-class="{'line-block' : !checkArrayHasChildren}"
      centered
      size="lg"
      :title="modalTitle"
    >
      <div style="margin-bottom: 15px">
        <a-breadcrumb separator=">">
          <a-breadcrumb-item>
            <div
              class="btn btn-icon base-btn"
              :class="[currentPage === 1 ? 'isActive':'']"
              style="display: inline-block;width: 36px;height: 36px;margin-right: 10px;cursor: auto;border-radius: 0.358rem;"
            >
              <feather-icon icon="MapPinIcon" />
            </div>
            <span
              class="base-font"
              :class="[currentPage === 1 ? 'isActive':'']"
              style="font-weight: 700;font-size:15px;margin-right: 15px"
            >Home</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <div
              class="btn btn-icon base-btn"
              :class="[currentPage === 2 ? 'isActive':'']"
              style="display: inline-block;width: 36px;height: 36px;margin-right: 10px;cursor: auto;border-radius: 0.358rem;"
            >
              <feather-icon icon="MapIcon" />
            </div>
            <span
              class="base-font"
              :class="[currentPage === 2 ? 'isActive':'']"
              style="font-weight: 700;font-size:15px;margin-right: 15px"
            >Baz</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="map-container">
        <template v-if="currentPage == 1">
          <map-block
            :show-map="true"
            :params="mapInfo"
            @changePoint="changePoint"
            @changeAera="changeAera"
          />
        </template>
        <template v-else-if="currentPage == 2">
          <b-form-input
            v-model="clockCardName"
            placeholder="请输入地址"
            type="text"
            class="d-inline-block"
          />
        </template>
      </div>
      <template #modal-footer>
        <b-button
          v-if="currentPage == 1"
          variant="outline-primary"
          @click="modelConfirm"
        >
          cancel
          <!-- {{ i18n('btns.confirm') }} -->
        </b-button>
        <b-button
          v-if="currentPage == 2"
          variant="outline-primary"
          @click="returnLast"
        >
          last
          <!-- {{ i18n('btns.confirm') }} -->
        </b-button>
        <b-button
          v-if="currentPage == 1"
          variant="primary"
          @click="checkNext"
        >
          next
        </b-button>
        <b-button
          v-if="currentPage == 2"
          variant="primary"
          @click="saveMap"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {
  BBadge, BModal, BButton, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import checkItem from '@/components/myForm/components/checkItem.vue';
import MapBlock from './map.vue';

export default {
  components: {
    // BBadge,
    BModal,
    BButton,
    MapBlock,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      dictOptions: [],
      dictCode: this.option.dictCode || this.option.dictBizCode,
      modalVisible: false,
      modalTitle: 'Title',
      selected: [],
      confirmSelect: [],
      coordinate: '',
      isActive: true,
      aera: '',
      clockCardName: '',
      currentPage: 1,
      mapInfo: {},
    }
  },
  computed: {
    checkedItems() {
      const res = []
      // 数组扁平化
      const menuFormat = data => {
        if (Array.isArray(data)) {
          const dataClone = deepClone(data)
          dataClone.forEach(item => {
            const element = {}
            element.label = item.label
            element.value = item.value
            if (Array.isArray(item.children)) {
              if (item.children.length > 0) {
                element.children = menuFormat(item.children)
              }
            }
            res.push(element)
          })
        }
      }
      menuFormat(this.dictOptions)
      return res.filter(o => this.confirmSelect.indexOf(o.value) !== -1) || []
    },
    checkArrayHasChildren() {
      let bool = false
      this.dictOptions.forEach(item => {
        if (item.children) {
          bool = true
        }
      })
      return bool
    },
  },
  watch: {
    coordinate: {
      deep: true,
      handler(e) {
        this.$emit('inputPosition', e)
      },
    },
    confirmSelect(e) {
      this.$emit('input', e.join())
    },
    value: {
      handler(e) {
        this.initDictOption(e)
      },
      deep: true,
      immediate: true,
    },
    'option.dictData': {
      handler(e) {
        if (e) {
          if (e.length > 0) {
            this.dictOptions = e
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkNext() {
      this.currentPage = 2
    },
    returnLast() {
      this.currentPage = 1
    },
    saveMap() {
      this.mapInfo = { coordinate: this.coordinate, aera: this.aera, clockCardName: this.clockCardName }
      this.modalVisible = false
      this.currentPage = 1
      this.$emit('input', this.mapInfo)
    },
    changePoint(coordinate) {
      this.coordinate = coordinate
    },
    changeAera(aera) {
      this.aera = aera
    },
    initDictOption(e) {
      if (e) {
        this.coordinate = e
        const { position, aera, clockCardName } = e
        this.coordinate = position
        this.aera = aera
        this.clockCardName = clockCardName
        this.mapInfo = { coordinate: this.coordinate, aera: this.aera, clockCardName: this.clockCardName }
      }
    },
    handleCheckClick(label) {
      this.modalVisible = true
      this.modalTitle = label
    },
    modelConfirm() {
      this.modalVisible = false
      this.currentPage = 1
      // this.$emit('input', this.coordinate)
      // if (!this.disabled) {
      //   this.confirmSelect = this.selected
      // }
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}

</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-select.scss';

.line-block{
  .check-item{
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>

.map-container {
  width: 100%;
  height: 300px;
}
.check{
  &-input{
    cursor: pointer;
    min-height: 2.714rem;
    height: auto;
    color:rgb(195, 195, 204)
  }
}
.badge-item{
  font-size: 16px;
  cursor: default;
  svg{
    cursor: pointer;
  }
}
.dark-layout{
  .check{
    &-input{
    border-color: #404656;
    background-color: #283046;
    }
  }
}

.base-btn {
  background: rgba($color: #ccc, $alpha: 0.3);
  // color: #fff;
}
.base-font {
  color: #ccc;
}
.isActive.base-btn {
  background: #7367f0;
  color: #fff;
}
.isActive.base-font {
  color: #7367f0;
}

</style>
